module.exports = __webpack_public_path__ + "assets/img/share-user-icon.a53d5ab2.png";